import { toDate } from './timestamps';

export const DEFAULT_PROPOSAL_PUBLIC_LINK_EXPIRY_DAYS = 30;

type ProposalPublicLinkState = {
    publicAccessToken?: unknown;
    publicSharedAt?: unknown;
    publicLinkExpiresAt?: unknown;
};

export function getProposalPublicLinkExpiresAt(proposal: ProposalPublicLinkState): number | null {
    if (proposal.publicLinkExpiresAt !== undefined && proposal.publicLinkExpiresAt !== null) {
        return toDate(proposal.publicLinkExpiresAt)?.getTime() ?? null;
    }

    const sharedAt = toDate(proposal.publicSharedAt)?.getTime();
    return sharedAt === null ? null : sharedAt + DEFAULT_PROPOSAL_PUBLIC_LINK_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
}

export function hasActiveProposalPublicLink(proposal: ProposalPublicLinkState, now = Date.now()): boolean {
    if (!String(proposal.publicAccessToken || '').trim() || !toDate(proposal.publicSharedAt)) return false;
    const expiresAt = getProposalPublicLinkExpiresAt(proposal);
    return expiresAt !== null && now < expiresAt;
}
